module.exports = __webpack_public_path__ + "static/media/sari.f507d6bb.jpeg";